module.exports = __webpack_public_path__ + "img/toilet-paper-solid.6f652bb1.svg";